export type QueryParamValue = string | number | boolean | null | undefined;

/** Query params as a screen describes them: a filter that is not set is `null` or `undefined`. */
export type QueryParams = Readonly<Record<string, QueryParamValue>>;

/** Query params as they go on the wire: only the ones that carry a value. */
export type CompactQueryParams = Readonly<Record<string, string | number | boolean>>;

/**
 * Leaves out the params that are `null` or `undefined`, so a filter that is not set is not sent at
 * all instead of arriving as `?status=null`. Empty strings, `0` and `false` are values and stay.
 */
export function compactParams(params: QueryParams): CompactQueryParams {
  const compact: Record<string, string | number | boolean> = {};

  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      compact[key] = value;
    }
  }

  return compact;
}

/** Whether two sets of params would produce the same request, whatever order the keys are in. */
export function sameParams(a: CompactQueryParams, b: CompactQueryParams): boolean {
  const keys = Object.keys(a);

  return (
    keys.length === Object.keys(b).length &&
    keys.every(key => Object.hasOwn(b, key) && a[key] === b[key])
  );
}
